export const buildProvenance = { "commitHash": "2448af0c8c958980ae4af558d1a1e72350ce9712", "branchName": "refs/heads/release/2024.4", "buildDate": "2025-02-13T04:24:02.461Z", "version": "2024.4.7158" };
